import { SystemConfig, SystemConfigFromJSON } from '@/api'
import {
  UpdateSystemConfigRequest,
  UpdateSystemConfigRequestToJSON
} from '@/api/models'
import * as runtime from '../runtime'

export class SystemConfigApi extends runtime.BaseAPI {
  async getAll(): Promise<SystemConfig[]> {
    const response = await this.requestGet(`/system-configs`)

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(SystemConfigFromJSON)
    ).value()
  }

  async getAlertValidate(): Promise<runtime.VoidApiResponse> {
    const response = await this.requestGet('/system-configs/validate')

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(SystemConfigFromJSON)
    ).value()
  }

  async update(
    id: number,
    request: UpdateSystemConfigRequest
  ): Promise<runtime.VoidApiResponse> {
    const response = await this.requestPut(
      `/system-configs/${id}`,
      UpdateSystemConfigRequestToJSON(request)
    )
    return new runtime.VoidApiResponse(response)
  }
}
